export const  BASE_URL="https://uae-en.shopkees.com/shpcpanel/seller_api/"
export const IMAGE_URL ="http://images.shopkees.com/uploads/cdn/images/100/"
export const APP_URL ="https://seller.shopkees.com/"